/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  let permissions: string[] = [];

  // 安全地解析权限数据
  try {
    const permissionStr = currentUser?.role?.permission;
    if (permissionStr) {
      // console.log("原始权限字符串:", permissionStr);

      // 修复单引号问题：将单引号替换为双引号
      const fixedStr = permissionStr.replace(/'/g, '"');
      // console.log("修复后的字符串:", fixedStr);

      permissions = JSON.parse(fixedStr);
      // console.log("解析后的权限数组:", permissions);
    }
  } catch (error) {
    console.error(
      '解析权限数据失败:',
      error,
      '原始数据:',
      currentUser?.role?.permission,
    );
    permissions = [];
  }

  return {
    // 判断菜单权限
    showEnum: (route: { path: string }) => {
      const routePath = route.path;
      //console.log('检查路由权限:', routePath, '权限列表:', permissions);
      if (!routePath) return false;

      // 2. 检查是否包含 '*',表示全选
      if (permissions.includes("*")) {
        return true;
      }

      // 1. 首先尝试完全匹配
      if (permissions.includes(`${routePath}`)) {
        //console.log('完全匹配成功:', routePath);
        return true;
      }
      return false;
    },
  };
}
